import type { PriceMatchFailureCode } from "./price-match-failure-codes.js";

export const PRICE_MATCH_FAILURE_RETRIEVAL_FAILED = "RETRIEVAL_FAILED" as const;
export const PRICE_MATCH_FAILURE_BRIGHT_DATA_RETRIEVAL_FAILED =
  "BRIGHT_DATA_RETRIEVAL_FAILED" as const;
export const PRICE_MATCH_FAILURE_NORMALIZATION_EXHAUSTED = "NORMALIZATION_EXHAUSTED" as const;
export const PRICE_MATCH_FAILURE_BEDROCK_EXHAUSTED = "BEDROCK_EXHAUSTED" as const;
export const PRICE_MATCH_FAILURE_EXTRACTION_FAILED = "EXTRACTION_FAILED" as const;

export const TEMPORARY_PRICE_MATCH_FAILURE_CODES = [
  PRICE_MATCH_FAILURE_RETRIEVAL_FAILED,
  PRICE_MATCH_FAILURE_BRIGHT_DATA_RETRIEVAL_FAILED,
  PRICE_MATCH_FAILURE_NORMALIZATION_EXHAUSTED,
  PRICE_MATCH_FAILURE_BEDROCK_EXHAUSTED,
  PRICE_MATCH_FAILURE_EXTRACTION_FAILED,
] as const satisfies readonly PriceMatchFailureCode[];

const temporaryFailureCodes: ReadonlySet<string> = new Set(TEMPORARY_PRICE_MATCH_FAILURE_CODES);

export function isTemporaryPriceMatchFailureCode(value: string | undefined): boolean {
  return value !== undefined && temporaryFailureCodes.has(value);
}
